/** File metadata checks; CSV contents are validated exclusively on the server. */
export const MAX_PATIENT_CSV_BYTES = 20 * 1024 * 1024;

/** Return an actionable selection error without reading patient data. */
export function validatePatientCsv(file: File): string | null {
  if (!file.name.toLowerCase().endsWith(".csv")) return "Choose a .csv file";
  if (file.size > MAX_PATIENT_CSV_BYTES) return "CSV must be at most 20 MiB";
  return null;
}

/** Extract server validation details from the shared API client's error response. */
export function patientIngestErrorMessage(error: unknown): string {
  const detail = (error as { body?: { detail?: unknown } })?.body?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (!item || typeof item !== "object") return "";
        const field = Array.isArray(item.loc)
          ? item.loc.slice(1).join(".")
          : "";
        return typeof item.msg === "string"
          ? `${field ? `${field}: ` : ""}${item.msg}`
          : "";
      })
      .filter(Boolean);
    if (messages.length) return messages.join("; ");
  }
  return error instanceof Error ? error.message : "Failed to start ingestion";
}
